import { render } from "./AssignUser.vue?vue&type=template&id=4405565b&scoped=true"
import script from "./AssignUser.vue?vue&type=script&lang=js"
export * from "./AssignUser.vue?vue&type=script&lang=js"

import "./AssignUser.vue?vue&type=style&index=0&id=4405565b&scoped=true&lang=css"
import "./AssignUser.vue?vue&type=style&index=1&id=4405565b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4405565b"]])

export default __exports__